var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "auth-page window-height window-width column justify-center items-center"
    },
    [
      _c("router-view"),
      _c("div", { staticClass: "absolute-bottom-left q-pa-md row" }, [
        _c("small", { staticClass: "q-mr-lg" }, [
          _c("div", { staticClass: "q-pt-md" }, [
            _c(
              "a",
              {
                staticClass: "legal-link text-faded",
                attrs: { target: "_blank", href: _vm.imprintLink }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("imprint")) + "\n        "
                )
              ]
            )
          ])
        ]),
        _c("small", [
          _c("div", { staticClass: "q-pt-md" }, [
            _c(
              "a",
              {
                staticClass: "legal-link text-faded",
                attrs: { target: "_blank", href: _vm.privacyPolicyLink }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("privacy_policy")) +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }